import { AbstractEntity, PropertyValuesDictionary, Transaction, UiData } from "plethora-lib" // GENERATED
import {
  DataTypeShapeType,
  DataTypeDirection,
  DataTypeSize,
  DataTypeColor,
} from "../GeneratedClasses/GeneratedDataTypes" // GENERATED
import { GeneratedTarget } from "../GeneratedClasses/GeneratedTarget" // GENERATED

export class Target extends GeneratedTarget {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super(id, propertyValues, uiData)

    const data = {
      id: this.id,
      posX: this.getX(),
      posY: this.getY(),
    }
    gameInstance.SendMessage("GridManager", "CreateTarget", JSON.stringify(data))
  }

  public onDelete(uiData: UiData): void /* GENERATED */ {
    super.onDelete(uiData)
    gameInstance.SendMessage("GridManager", "DestroyTargetFromPlethora", this.id)
  }

  public onDestory(): void /* GENERATED */ {
    super.onDestory()
    // YOUR CODE HERE
  }

  public onSetHighlight(highlight: boolean): void /* GENERATED */ {
    super.onSetHighlight(highlight)
    // YOUR CODE HERE
  }

  protected onXUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onYUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onClick(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onMeets(isActivator: boolean, otherEntity: AbstractEntity, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }
}
